var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 26.051,
    viewBox: "0 0 68 26.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_513",
    "data-name": "Group 513",
    transform: "translate(-1549 -131.535)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "\\u0411\\u0430\\u0440\\u0430\\u0458",
    transform: "translate(1549 134)",
    fill: "#707070",
    fontSize: 14,
    fontFamily: "Montserrat-Regular, Montserrat",
    letterSpacing: "0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -41,
    y: 14
  }, "\u0411\u0430\u0440\u0430\u0458")), /*#__PURE__*/React.createElement("g", {
    id: "Search",
    transform: "translate(1549 131.535)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1523",
    "data-name": "Rectangle 1523",
    fill: "none",
    stroke: "#0061af",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.568,
    height: 20.131,
    rx: 10.066,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 17.568,
    height: 17.131,
    rx: 8.566,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x2: 6.28,
    y2: 6.147,
    transform: "translate(17.516 17.783)",
    fill: "none",
    stroke: "#0061af",
    strokeLinecap: "round",
    strokeWidth: 3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0683465de096e612b93e09c9ee718aa8.svg";
export { ForwardRef as ReactComponent };